import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

export const initCtaSlider = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(".cta-slider .swiper");

  if (sliders.length === 0) {
    return;
  }

  sliders.forEach((sliderElement) => {
    new Swiper(sliderElement, {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });

  console.log("[Slider] CTA Slider initialized.");
};
